import React from "react";
import { theme, Tooltip } from 'antd';
import {
  PlusCircleFilled,
  EditOutlined,
} from '@ant-design/icons';
import ColorButton from "../../common/ColorButton";
import TSTable from "../../common/TSTable";
import { URL_SKIM } from "../../constants/urls";
import { dateTimeToHumanString } from "../../frameworks/Util";
import ErrorMessages from "../../common/ErrorMessages";
import { DELETE } from "../../frameworks/HttpClient";
import CustomDeleteConfirmButton from "../../common/CustomDeleteConfirmButton";
import AddSkimChemicalModal from "./AddSkimChemicalModal";

export default function SkimChemicalList(props) {
  const [ errorMessages, setErrorMessages ] = React.useState(false);
  const [ chemicalTarget, setChemicalTarget] = React.useState(null);
  const tableRef = React.useRef(null);
  const {
    token: { colorSuccess },
  } = theme.useToken();

  const { token : { colorWarning }} = theme.useToken();

  const columns = [
    {
      title: 'Action',
      dataIndex: '',
      width : 150,
      key: 'action',
      render: (_, original) => {
        return (
          <div 
            style={{textAlign:'center'}}
            onClick={(e) => {
              e.stopPropagation()
            }}
          >
            {!original.is_closed &&               
              <CustomDeleteConfirmButton
                tooltips={'ลบชื่อสารเคมี'}
                title={`ลบชื่อสารเคมีสกิม - ${original.name}`}
                content={"คุณต้องการลบชื่อสารเคมีใช่หรือไม่"}
                onOk={ async() => {
                  await handleDeleteChemical(original.id)
                  refreshData();
                }}
                onConfirm={() => refreshData()}
            />}
            {!original.is_closed && <Tooltip triger='hover' title="แก้ไข">
              <ColorButton 
                type='primary'
                override={colorWarning}
                icon={<EditOutlined />}
                style={{ margin : 5}}
                onClick={()=> setChemicalTarget(original)} 
              />
            </Tooltip>}
          </div>
      )}
    },
    {
      title: 'ชื่อสารเคมี',
      dataIndex: 'name',
      key: 'name',
      searcher: true,
    },
    {
      title: 'วันที่สร้าง',
      dataIndex: 'created',
      key: 'created',
      render : (value) => dateTimeToHumanString(value)
    },
    {
      title: 'วันที่แก้ไขล่าสุด',
      dataIndex: 'updated',
      key: 'updated',
      render : (value) => dateTimeToHumanString(value)
    },
  ]

  const handleDeleteChemical = async(id) => {
    setErrorMessages(null)
    try {
      await DELETE(`${URL_SKIM.SKIM_CHEMICAL}${id}/`)
    } catch (error) {
      setErrorMessages(error.errorMessages)
    }
  }

  const refreshData = async() => {
    if(tableRef.current)(
      await tableRef.current.fetchWithoutResetPage()
    )
  }
  

  return(
    <div>
      <ErrorMessages message={errorMessages}></ErrorMessages>
      <ColorButton
        type={'primary'}
        override={colorSuccess}
        style={{ float : 'right', marginBottom : 10}}
        icon={<PlusCircleFilled />} 
        onClick={() => setChemicalTarget('add')}>
          {"เพิ่มชื่อสารเคมีสกิม"}
      </ColorButton>

      <TSTable
        ref={tableRef}
        columns={columns}
        size={'small'}
        url={URL_SKIM.SKIM_CHEMICAL}
      />

      <AddSkimChemicalModal
        open={chemicalTarget ? true : false}
        onClose={() => setChemicalTarget(null)}
        onUpdate={() => {
          setChemicalTarget(null)
          refreshData();
        }}
        target={chemicalTarget}
      />
    </div>
  )
}